module.exports = __webpack_public_path__ + "static/img/bgmCat.1e1a5b74.png";